import * as _ from 'lodash'
import { VNumber, not, all, if as _if, VBoolean } from 'alkali'
import RowPanes, { RowPanesOpts } from './RowPanes'
import GroupsTable from './GroupsTable'
import ExtractionModel from './model/ExtractionModel'
import { FocusedState } from './ExtractAnnotationModel'
import { createExtractRow } from 'services/extract/generate'

interface OutcomeRowsOpts extends RowPanesOpts {
	extractionModel: ExtractionModel
	focusedState: FocusedState
	activeIndex: VNumber
}

export default class OutcomeRows extends RowPanes {
	private extractionModel: ExtractionModel
	created(props: OutcomeRowsOpts) {
		const { extractionModel, focusedState, activeIndex } = props
		const prefix = _if(extractionModel.editingExtraction, ['Editing', 'Adding'])
		props.items = extractionModel.extraction.outcomes.map(outcome => ({
			header: all([prefix, outcome], (p, outcome) =>
				p + ' '
				  + (outcome.name?.val || 'new outcome')
				  + (outcome.timepoint?.val ? (' ' + outcome.timepoint?.val) : '')
			),
			body: new GroupsTable({ row: outcome, extractionModel, focusedState, activeIndex, section: 'outcomes', rowTypeTitle: 'Outcome' })
		}))
		props.addable = new VBoolean(false) //not(extractionModel.editingExtraction)
		super.created(props)
	}

	protected addRow() {
		this.extractionModel.extraction.outcomes.push(createExtractRow('Outcomes'))
		this.open.put(this.extractionModel.extraction.outcomes.length.valueOf() - 1)
	}

	protected onRemove(item, i) {
		// detach the UI eagerly to avoid running transforms on removed item
		const panes = this.items.valueOf()
		panes[i].body.remove()
		_.defer(() => {
			this.extractionModel.extraction.outcomes.splice(i, 1)
			const curOpen = this.open.valueOf()
			if (curOpen == i && i > 0) {
				this.open.put(i - 1)
			}
		})
	}
}